// extracted by mini-css-extract-plugin
module.exports = {"modal":"EmailModal__modal__3ljXj","detailsWrapper":"EmailModal__detailsWrapper__2S17C","email":"EmailModal__email__2N671","footer":"EmailModal__footer__3oGVT"};